import React from "react";
import { Link } from "react-router-dom";
import {
  FiClock,
  FiCalendar,
  FiChevronRight,
  FiMail,
  FiMapPin,
  FiPhone,
  FiUsers,
  FiFileText,
  FiMessageSquare,
  FiShield,
  FiBell,
  FiHelpCircle,
  FiBookOpen,
} from "react-icons/fi";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { HiHome } from "react-icons/hi";
import "./FooterNew.css";

const Footer = () => {
  const helpfulLinks = [
    { label: "About Us", path: "/aboutus", icon: <FiUsers /> },
    { label: "Contact Us", path: "/contactus", icon: <FiMail /> },
    { label: "Terms & Conditions", path: "/termsandconditions", icon: <FiFileText /> },
    { label: "Feedback", path: "/feedback", icon: <FiMessageSquare /> },
    { label: "Privacy Policy", path: "/privacypolicy", icon: <FiShield /> },
    { label: "Summons/Notices", path: "/summonsnotices", icon: <FiBell /> },
    { label: "Grievances", path: "/Grievance", icon: <FiHelpCircle /> },
    { label: "Safety Guide", path: "/safetyGuide", icon: <FiBookOpen /> },
  ];

  return (
    <footer className="mgh-footer-wrap">
      {/* Top Footer Content */}
      <div className="mgh-footer-top">
        <div className="mgh-footer-grid">
          {/* Column 1: Brand Info */}
          <div className="mgh-footer-col-brand">
            <Link to="/" className="mgh-footer-logo-link" aria-label="EwRealty Home">
              <img
                src="/assets/images/logo4.png"
                alt="EwRealty"
                className="mgh-footer-logo-img"
              />
            </Link>

            <p className="mgh-footer-desc">
              Discover your dream home with EwRealty. Explore verified listings,
              curated properties, and expert neighborhood insights for residential and commercial
              real estate in Hyderabad.
            </p>

            <div className="mgh-footer-hours">
              <div className="mgh-footer-hour-item">
                <span className="mgh-footer-hour-icon">
                  <FiClock />
                </span>
                <span>
                  Monday - Friday: <strong className="mgh-footer-hour-time">8am - 6pm</strong>
                </span>
              </div>
              <div className="mgh-footer-hour-item">
                <span className="mgh-footer-hour-icon">
                  <FiCalendar />
                </span>
                <span>
                  Saturday - Sunday: <strong className="mgh-footer-hour-time">9am - 3pm</strong>
                </span>
              </div>
            </div>
          </div>

          {/* Column 2: Helpful Links */}
          <div className="mgh-footer-col-links">
            <h4 className="mgh-footer-title">Helpful Links</h4>
            <span className="mgh-footer-title-line"></span>

            <ul className="mgh-footer-links-list">
              {helpfulLinks.map((link, idx) => (
                <li key={idx} className="mgh-footer-link-item">
                  <Link to={link.path}>
                    <span className="mgh-footer-link-left">
                      <span className="mgh-footer-link-icon">{link.icon}</span>
                      <span className="mgh-footer-link-text">{link.label}</span>
                    </span>
                    <span className="mgh-footer-link-arrow">
                      <FiChevronRight />
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div className="mgh-footer-col-contact">
            <h4 className="mgh-footer-title">Contact Info</h4>
            <span className="mgh-footer-title-line"></span>

            <div className="mgh-footer-contacts-list">
              {/* Phone */}
              <a href="tel:+919063483711" className="mgh-footer-contact-item" title="Call Customer Care">
                <div className="mgh-footer-contact-circle mgh-footer-contact-phone" aria-hidden="true">
                  <FiPhone />
                </div>
                <div className="mgh-footer-contact-text">
                  <span className="mgh-footer-contact-label">Phone Support</span>
                  <span className="mgh-footer-contact-value">+91 9063483711</span>
                </div>
              </a>

              {/* Mail */}
              <a href="mailto:info@ewrealty.com" className="mgh-footer-contact-item" title="Send an Email">
                <div className="mgh-footer-contact-circle mgh-footer-contact-mail" aria-hidden="true">
                  <FiMail />
                </div>
                <div className="mgh-footer-contact-text">
                  <span className="mgh-footer-contact-label">Email Support</span>
                  <span className="mgh-footer-contact-value">info@ewrealty.com</span>
                </div>
              </a>

              {/* Address */}
              <div className="mgh-footer-contact-item">
                <div className="mgh-footer-contact-circle mgh-footer-contact-location" aria-hidden="true">
                  <FiMapPin />
                </div>
                <div className="mgh-footer-contact-text">
                  <span className="mgh-footer-contact-label">Office Location</span>
                  <span className="mgh-footer-contact-value">Hyderabad, Telangana, India</span>
                </div>
              </div>
            </div>
          </div>

          {/* Column 4: Follow Us */}
          <div className="mgh-footer-col-follow">
            <h4 className="mgh-footer-title">Follow Us</h4>
            <span className="mgh-footer-title-line"></span>

            <p className="mgh-footer-follow-desc">
              Connect with us for verified project launches, price trends, and property updates in Hyderabad.
            </p>

            <div className="mgh-footer-social-row">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="mgh-footer-social-btn mgh-social-fb" aria-label="Facebook" title="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="mgh-footer-social-btn mgh-social-ig" aria-label="Instagram" title="Instagram">
                <FaInstagram />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="mgh-footer-social-btn mgh-social-li" aria-label="LinkedIn" title="LinkedIn">
                <FaLinkedinIn />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="mgh-footer-social-btn mgh-social-yt" aria-label="YouTube" title="YouTube">
                <FaYoutube />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="mgh-footer-social-btn mgh-social-tw" aria-label="Twitter" title="Twitter">
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Sub-Footer (Bottom Dark Navy Bar) */}
      <div className="mgh-sub-footer">
        <div className="mgh-sub-footer-inner">
          <p className="mgh-sub-footer-copyright">
            © {new Date().getFullYear()} EwRealty | All rights reserved.
          </p>
          <div className="mgh-sub-footer-links">
            <Link to="/termsandconditions" className="mgh-sub-footer-link">Terms of Use</Link>
            <Link to="/privacypolicy" className="mgh-sub-footer-link">Privacy Policy</Link>
            <Link to="/aboutus" className="mgh-sub-footer-link">About Us</Link>
            <Link to="/contactus" className="mgh-sub-footer-link">Contact Us</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
